import React, { useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import EditorJS from '@editorjs/editorjs';

import { addInstructionEventByEditor } from '../utils';
import { InstructionEvent } from '../types';
import {
  setOpenNoteInstructionModal,
  setInlineNoteInstruction,
  setNoteInstructionId,
} from '../../../../store/modules/script-editor/actions';
import { selectNoteInstruction } from '../../../../store/modules/script-editor/selectors';
import { addEventListenerNoteActions } from './utils';
import NoteInstructionModal from './NoteInstructionModal';

type Props = {
  instanceEditor: EditorJS | undefined;
  refEditor: HTMLDivElement | null;
};

const NoteInstructionComponent = ({ instanceEditor, refEditor }: Props) => {
  const dispatch = useDispatch();
  const { isOpenModal } = useSelector(selectNoteInstruction);

  useEffect(() => {
    if (instanceEditor) {
      addInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.OPEN_NOTE_INSTRUCTION_MODAL,
        (data) => {
          dispatch(setOpenNoteInstructionModal(true));
          dispatch(setNoteInstructionId(data.instructionId));
          dispatch(setInlineNoteInstruction(data.isInline));
        },
      );
      addInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.UPDATE_NOTE_ACTION_EVENT_LISTENERS,
        // eslint-disable-next-line
        ({ refEditor, instanceEditor }) => {
          addEventListenerNoteActions({ instanceEditor, refEditor });
        },
      );
    }
  }, [dispatch, instanceEditor]);

  useEffect(() => {
    if (instanceEditor && refEditor) {
      addEventListenerNoteActions({ instanceEditor, refEditor });
    }
  }, [instanceEditor, refEditor]);

  if (!isOpenModal) {
    return null;
  }

  return (
    <NoteInstructionModal instanceEditor={instanceEditor} />
  );
};

export default NoteInstructionComponent;
